import { Action } from '@ngrx/store';
import { IPaymentConfig, ITaxSubsection, IPaymentOption, IPaymentProcessor } from 'src/commons';

export enum PaymentConfigActionTypes {
  LoadPaymentConfigState = '[PaymentConfig] Load PaymentConfig State',
  LoadPaymentConfigStateSuccess = '[PaymentConfig] Load PaymentConfig State Success',
  LoadPaymentConfigStateFail = '[PaymentConfig] Load PaymentConfig State Fail',
  PaymentConfigScreenErrorReset = '[PaymentConfig] PaymentConfig Screen Error Reset',
  UpdatePaymentConfigState = '[PaymentConfig] Update Payment Config State',
  LoadSubsectionsState = '[PaymentConfig] Load Subsection State',
  LoadSubsectionsStateSuccess = '[PaymentConfig] Load Subsection State Success',
  UpdateSubsectionsState = '[PaymentConfig] Update Subsection State',
  LoadPaymentOptionState = '[PaymentConfig] Load Payment Options State',
  LoadPaymentOptionStateSuccess = '[PaymentConfig] Load Payment Options State Success',
  UpdatePaymentOptionState = '[PaymentConfig] Update Payment Option State',
  LoadPaymentProcessorState = '[PaymentConfig] Load Payment Processor State',
  LoadPaymentProcessorStateSuccess = '[PaymentConfig] Load Payment Processor State Success',
  UpdatePaymentProcessorState = '[PaymentConfig] Update Payment Processor State',
  LoadPaymentConfigStateInit = '[PaymentConfig] Load PaymentConfig Init State'

}

export class LoadPaymentConfigState implements Action {
  readonly type = PaymentConfigActionTypes.LoadPaymentConfigState;
}

export class LoadPaymentConfigStateSuccess implements Action {
  readonly type = PaymentConfigActionTypes.LoadPaymentConfigStateSuccess;
  constructor(public payload: IPaymentConfig[]) { }
}

export class LoadPaymentConfigStateFail implements Action {
  readonly type = PaymentConfigActionTypes.LoadPaymentConfigStateFail;
  constructor(public payload: any) { }
}

export class UpdatePaymentConfigState implements Action {
  readonly type = PaymentConfigActionTypes.UpdatePaymentConfigState;
  constructor(public payload: IPaymentConfig) { }
}

export class PaymentConfigScreenErrorReset implements Action {
  readonly type = PaymentConfigActionTypes.PaymentConfigScreenErrorReset;
}

export class LoadSubsectionsState implements Action {
  readonly type = PaymentConfigActionTypes.LoadSubsectionsState;
}

export class LoadSubsectionsStateSuccess implements Action {
  readonly type = PaymentConfigActionTypes.LoadSubsectionsStateSuccess;
  constructor(public payload: ITaxSubsection[]) { }
}

export class UpdateSubsectionsState implements Action {
  readonly type = PaymentConfigActionTypes.UpdateSubsectionsState;
  constructor(public payload: ITaxSubsection[]) { }
}

export class LoadPaymentOptionState implements Action {
  readonly type = PaymentConfigActionTypes.LoadPaymentOptionState;
}

export class LoadPaymentOptionStateSuccess implements Action {
  readonly type = PaymentConfigActionTypes.LoadPaymentOptionStateSuccess;
  constructor(public payload: IPaymentOption[]) { }
}

export class UpdatePaymentOptionState implements Action {
  readonly type = PaymentConfigActionTypes.UpdatePaymentOptionState;
  constructor(public payload: IPaymentOption[]) { }
}

export class LoadPaymentProcessorState implements Action {
  readonly type = PaymentConfigActionTypes.LoadPaymentProcessorState;
}

export class LoadPaymentProcessorStateSuccess implements Action {
  readonly type = PaymentConfigActionTypes.LoadPaymentProcessorStateSuccess;
  constructor(public payload: IPaymentProcessor[]) { }
}

export class UpdatePaymentProcessorState implements Action {
  readonly type = PaymentConfigActionTypes.UpdatePaymentProcessorState;
  constructor(public payload: IPaymentProcessor[]) { }
}

export class LoadPaymentConfigStateInit implements Action {
  readonly type = PaymentConfigActionTypes.LoadPaymentConfigStateInit;
}


export type PaymentConfigActions =
  LoadPaymentConfigState
  | LoadPaymentConfigStateSuccess
  | LoadPaymentConfigStateFail
  | PaymentConfigScreenErrorReset
  | UpdatePaymentConfigState
  | LoadSubsectionsState
  | LoadSubsectionsStateSuccess
  | UpdateSubsectionsState
  | LoadPaymentOptionState
  | LoadPaymentOptionStateSuccess
  | UpdatePaymentOptionState
  | LoadPaymentProcessorState
  | LoadPaymentProcessorStateSuccess
  | UpdatePaymentProcessorState
  | LoadPaymentConfigStateInit;